export default {
      id: "phone-usage",
      viewBox: "0 0 20 19",
      url: __webpack_public_path__ + "assets/sprite.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./assets/svg/phone.svg
// module id = ./assets/svg/phone.svg
// module chunks = 0